import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-record-historico',
  templateUrl: './record-historico.component.html',
  styleUrls: ['./record-historico.component.scss'],
  providers: [DatePipe]
})
export class RecordHistoricoComponent implements OnInit {

  tituloPantalla = "RECORD HISTORICO";

  @Input() cintillo = "";
  @Input() ahora: Date = null;

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

}
